/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Home from './Home';
import { homeFetch, needWindow } from '../../actions/home';
import { fetchHotWords } from '../../actions/search';
import { trackEventLog } from '../../core/utils'

async function action({ store }) {
  trackEventLog('/w/')
  await store.dispatch(needWindow())
  await store.dispatch(homeFetch())
  await store.dispatch(fetchHotWords(''))
  // if (!store.getState().home.fixedEntries.length) await store.dispatch(homeFetch());
  if (global && global.NProgress) {
    global.NProgress.done()
  }
  return {
    chunks: ['home'],
    title: '有道精品课',
    keywords: '有道精品课,网易有道,有道博闻,有道英语,有道领世,有道纵横,有道小图灵,有道思维,在线教育,在线课堂,围棋,象棋,国际象棋,名师,小学,初中,高中,兴趣,素养,英语,升学,大学,语文,数学,思维,AI,考研,四六级,雅思,听说口语,小语种,专四专八,成人教育,职业考证',
    description: '有道精品课是网易旗下的知名培优教育品牌，致力于培养未来更具竞争力的优秀少年。提供英语国际、语文人文、数学思维、编程、围棋、象棋等素养类课程，覆盖小学、初中、高中全学段。卓越师资、小班教学、培优体系，用专业方法帮助孩子长效提升',
    component: <Home />,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/home/index.js